/**
 * @generated SignedSource<<899fde681cab26e538f6d5bc2e21cd1d>>
 * @relayHash e29ee33c92b0392a0cd0c7435eb215f3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b340a530658267efdb07654837d9e4e6b16986d6779f565d429fb6ddf4900bb3

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceStaticMacroRenderErrorCode = "INVOCATION_FAILED" | "%future added value";
export type ContentRepresentationV2 = "atlas_doc_format" | "editor" | "editor2" | "export_view" | "plain" | "raw" | "storage" | "styled_view" | "view" | "wiki" | "%future added value";
export type MacroRendererMode = "EDITOR" | "PDF" | "RENDERER" | "%future added value";
export type multiMacroQueryWithAppKeyQuery$variables = {
  after?: string | null;
  blocklist?: ReadonlyArray<string> | null;
  cloudId: string;
  contentId: string;
  first?: number | null;
  mode?: MacroRendererMode | null;
  refetchToken?: string | null;
  staticAfter?: string | null;
  staticFirst?: number | null;
};
export type multiMacroQueryWithAppKeyQuery$data = {
  readonly macros: {
    readonly nodes: ReadonlyArray<{
      readonly contentId: string;
      readonly macroId: string;
      readonly renderedMacro: {
        readonly appKey: string | null;
        readonly macroBodyStorage: string | null;
        readonly macroRenderedRepresentation: ContentRepresentationV2 | null;
        readonly mediaToken: {
          readonly token: string | null;
        } | null;
        readonly value: string | null;
        readonly webResource: {
          readonly contexts: ReadonlyArray<string | null>;
          readonly keys: ReadonlyArray<string | null>;
          readonly superbatch: {
            readonly metatags: string | null;
          } | null;
          readonly tags: {
            readonly css: string | null;
            readonly data: string | null;
            readonly js: string | null;
          } | null;
          readonly uris: {
            readonly css: ReadonlyArray<string | null> | null;
            readonly data: ReadonlyArray<string | null> | null;
            readonly js: ReadonlyArray<string | null> | null;
          } | null;
        } | null;
      } | null;
    } | null> | null;
    readonly pageInfo: {
      readonly endCursor: string | null;
      readonly hasNextPage: boolean;
    };
  } | null;
  readonly staticMacros: {
    readonly nodes: ReadonlyArray<{
      readonly error: {
        readonly code: ConfluenceStaticMacroRenderErrorCode;
      } | null;
      readonly macroId: string;
      readonly value: string | null;
    }> | null;
    readonly pageInfo: {
      readonly endCursor: string | null;
      readonly hasNextPage: boolean;
    };
  } | null;
};
export type multiMacroQueryWithAppKeyQuery = {
  response: multiMacroQueryWithAppKeyQuery$data;
  variables: multiMacroQueryWithAppKeyQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "blocklist"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v5 = {
  "defaultValue": "RENDERER",
  "kind": "LocalArgument",
  "name": "mode"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "refetchToken"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "staticAfter"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "staticFirst"
},
v9 = {
  "kind": "Variable",
  "name": "contentId",
  "variableName": "contentId"
},
v10 = {
  "concreteType": "PageInfoV2",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    },
    {
      "kind": "ScalarField",
      "name": "endCursor"
    }
  ]
},
v11 = {
  "kind": "ScalarField",
  "name": "macroId"
},
v12 = {
  "kind": "Variable",
  "name": "mode",
  "variableName": "mode"
},
v13 = {
  "kind": "ScalarField",
  "name": "value"
},
v14 = [
  {
    "kind": "ScalarField",
    "name": "css"
  },
  {
    "kind": "ScalarField",
    "name": "data"
  },
  {
    "kind": "ScalarField",
    "name": "js"
  }
],
v15 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
      },
      {
        "kind": "Variable",
        "name": "blocklist",
        "variableName": "blocklist"
      },
      (v9/*: any*/),
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      },
      {
        "kind": "Variable",
        "name": "refetchToken",
        "variableName": "refetchToken"
      }
    ],
    "concreteType": "MacroConnection",
    "kind": "LinkedField",
    "name": "macros",
    "plural": false,
    "selections": [
      (v10/*: any*/),
      {
        "concreteType": "Macro",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v11/*: any*/),
          {
            "kind": "ScalarField",
            "name": "contentId"
          },
          {
            "args": [
              (v12/*: any*/)
            ],
            "concreteType": "RenderedMacro",
            "kind": "LinkedField",
            "name": "renderedMacro",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "appKey"
              },
              (v13/*: any*/),
              {
                "kind": "ScalarField",
                "name": "macroRenderedRepresentation"
              },
              {
                "kind": "ScalarField",
                "name": "macroBodyStorage"
              },
              {
                "concreteType": "WebResourceDependenciesV2",
                "kind": "LinkedField",
                "name": "webResource",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "contexts"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "keys"
                  },
                  {
                    "concreteType": "SuperBatchWebResourcesV2",
                    "kind": "LinkedField",
                    "name": "superbatch",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "metatags"
                      }
                    ]
                  },
                  {
                    "concreteType": "WebResourceTagsV2",
                    "kind": "LinkedField",
                    "name": "tags",
                    "plural": false,
                    "selections": (v14/*: any*/)
                  },
                  {
                    "concreteType": "WebResourceUrisV2",
                    "kind": "LinkedField",
                    "name": "uris",
                    "plural": false,
                    "selections": (v14/*: any*/)
                  }
                ]
              },
              {
                "concreteType": "EmbeddedMediaTokenV2",
                "kind": "LinkedField",
                "name": "mediaToken",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "token"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "alias": "staticMacros",
    "args": [
      {
        "kind": "Variable",
        "name": "after",
        "variableName": "staticAfter"
      },
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      (v9/*: any*/),
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "staticFirst"
      },
      (v12/*: any*/)
    ],
    "concreteType": "ConfluenceStaticMacroRenderedConnection",
    "kind": "LinkedField",
    "name": "confluence_staticMacros",
    "plural": false,
    "selections": [
      (v10/*: any*/),
      {
        "concreteType": "ConfluenceStaticMacroRendered",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v11/*: any*/),
          (v13/*: any*/),
          {
            "concreteType": "ConfluenceStaticMacroRenderError",
            "kind": "LinkedField",
            "name": "error",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "code"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Fragment",
    "name": "multiMacroQueryWithAppKeyQuery",
    "selections": (v15/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v2/*: any*/),
      (v5/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/),
      (v8/*: any*/),
      (v7/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Operation",
    "name": "multiMacroQueryWithAppKeyQuery",
    "selections": (v15/*: any*/)
  },
  "params": {
    "cacheID": "e29ee33c92b0392a0cd0c7435eb215f3",
    "id": "b340a530658267efdb07654837d9e4e6b16986d6779f565d429fb6ddf4900bb3",
    "metadata": {},
    "name": "multiMacroQueryWithAppKeyQuery",
    "operationKind": "query",
    "text": "query multiMacroQueryWithAppKeyQuery($contentId:ID!,$cloudId:ID!,$mode:MacroRendererMode=RENDERER,$blocklist:[String!],$first:Int,$after:String,$staticFirst:Int,$staticAfter:String,$refetchToken:String)@allowHigherTimeout{macros(contentId:$contentId,blocklist:$blocklist,first:$first,after:$after,refetchToken:$refetchToken){pageInfo{hasNextPage,endCursor},nodes{macroId,contentId,renderedMacro(mode:$mode){appKey,value,macroRenderedRepresentation,macroBodyStorage,webResource{contexts,keys,superbatch{metatags},tags{css,data,js},uris{css,data,js}},mediaToken{token}}}},staticMacros:confluence_staticMacros(contentId:$contentId,cloudId:$cloudId,first:$staticFirst,after:$staticAfter,mode:$mode)@optIn(to:[\"AskInCcApiPlatformBeforeUsing\"]){pageInfo{hasNextPage,endCursor},nodes{macroId,value,error{code}}}}"
  }
};
})();

(node as any).hash = "cb59fd86fa898e9d156d89c1de0cdd77";

export default node;
